import React, { useState } from 'react';
import axios from 'axios';

const TelegramUploader = () => {
  const [mediaType, setMediaType] = useState('Video');
  const [link, setLink] = useState('');
  const [chatId, setChatId] = useState('-1001978124511');
  const [caption, setCaption] = useState('');

  const handleMediaTypeChange = (e) => {
    setMediaType(e.target.value);
  };

  const handleLinkChange = (e) => {
    setLink(e.target.value);
  };

  const handleChatIdChange = (e) => {
    setChatId(e.target.value);
  };

  const handleCaptionChange = (e) => {
    setCaption(e.target.value);
  };

  const handleSendToTelegram = async () => {
    try {
      // You'll need to replace 'YOUR_TELEGRAM_BOT_TOKEN' with your actual Telegram bot token.
      const botToken = '6616462624:AAFOPjNLpXy7Q2AZGR0uFkPBugdB3ACdfF8';

      const options = {
        method: 'POST',
        url: `https://api.telegram.org/bot${botToken}/send${mediaType}`,
        headers: {
          accept: 'application/json',
          'User-Agent': 'Telegram Bot SDK - (https://github.com/irazasyed/telegram-bot-sdk)',
          'content-type': 'application/json',
        },
        data: {
          [mediaType.toLowerCase()]: link,
          caption: caption,
          disable_notification: false,
          chat_id: chatId, // Added chat_id here.
        },
      };

      const response = await axios.request(options);

      if (response.status === 200) {
        alert('Message sent to Telegram successfully!');
        // You can add more handling here if needed.
      }
    } catch (error) {
      console.error('Error sending message to Telegram:', error);
      // Handle errors here if necessary.
    }
  };

  return (
    <div className="container mx-auto p-4">
      <h1 className="text-3xl font-bold mb-6 text-center">Telegram Media Uploader</h1>
      <div className="flex flex-col gap-6 ">
        <div >
          <label htmlFor="mediaType" className="block font-semibold text-gray-700 mb-2">
            Media Type:
          </label>
          <select
            id="mediaType"
            onChange={handleMediaTypeChange}
            value={mediaType}
            className="border p-2 w-full rounded-md"
          >
            <option value="Video">Video</option>
            <option value="Photo">Photo</option>
            <option value="Audio">Audio</option>
            <option value="Document">Document</option>
            {/* You can add options for other media types if needed */}
          </select>
        </div>
        <div>
          <label htmlFor="link" className="block font-semibold text-gray-700 mb-2">
            Enter {mediaType} Link:
          </label>
          <input
            type="text"
            id="link"
            placeholder={`Enter ${mediaType} link...`}
            value={link}
            onChange={handleLinkChange}
            className="border p-2 w-full rounded-md"
          />
        </div>
        <div>
          <label htmlFor="chatId" className="block font-semibold text-gray-700 mb-2">
            Enter Chat ID:
          </label>
          <input
            type="text"
            id="chatId"
            placeholder="Enter Chat ID..."
            value={chatId}
            onChange={handleChatIdChange}
            className="border p-2 w-full rounded-md"
          />
        </div>
        <div>
          <label htmlFor="caption" className="block font-semibold text-gray-700 mb-2">
            Enter Caption:
          </label>
          <input
            type="text"
            id="caption"
            placeholder="Enter Caption..."
            value={caption}
            onChange={handleCaptionChange}
            className="border p-2 w-full rounded-md"
          />
        </div>
      </div>
      <div className="text-center mt-6">
        <button
          onClick={handleSendToTelegram}
          className="bg-blue-500 text-white px-4 py-2 rounded hover:bg-blue-600 cursor-pointer"
        >
          Send to Telegram
        </button>
      </div>
    </div>
  );
};

export default TelegramUploader;
